module.exports = __webpack_public_path__ + "static/media/PW.9b5d4dc2.svg";